import {InstagramUserBean} from "./instagram.user.bean"
import {CompanyBean} from "./company.bean"


export class EventBean {
  public id          : number;//
  public vippoints:number=0;
  public memberOnly=false;
  public channel='';
  public avatarVersion=2;
  public isWorld=false;
  public kind;
  public attractions     : string;//
  public report: any;
  public email;
  public gamepath: string='https://viplista.com.br/liveparty'
  public jitsiServer
  public benefitThumbnail       : string;//
  public benefits        : string;//
  public styles: string;//
  public private:boolean=false;
  public room:string
  public rooms: string[]
  public videoDesk;
  public videoMobile;
  public temporaryVideoLink;

  public avatar;
  public hasQrCode: boolean=false;
  public controlList:string='';
  public app:string;
  public outsideLink: string;
  public video: string='';
  public teleEvent: boolean=true;
  public gameEvent: boolean=false;

  public latitude:number;//
  public longitude:number;//
  public description:string;//
  public date: string;//
  public dateStart: number;//
  public dateEnd: number;
  public name: string;//
  public price: string;//
  public website:string;
  public code:string;
  public password:string;
  public hls: string=''
  public shortDescription: string;//
  public thumbnail: string="/assets/images/uploading.gif";//
  public icon: string="/assets/images/uploading.gif";
  public hasVideo=true;
  public hasAudio=true;
  public admins=['T6sKpIAzwlPlYmEGgy2FuolQ2wN2'];
  public banned=[]
  public incognito=false;
  public passwords: {}
  public addressName:string;
  public addressComplement: string;
  public promoter:string;
  public company:CompanyBean;
  public instagram:string;
  public hour: string;
  public list:InstagramUserBean[];
  public thumbnails:string[];
  public promotionURL: string;
  public companyId: string;
  public skills: any[];
  public easyCheckout:boolean;
  public externalId;
  public externalToken;
};



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/Event.ts